import { CoreOperationExecutor } from "../../../core/index.js";
import * as Operations from "../operation/index.js";
import { executeDataPsmSetUseKeyValueForLangString } from "./data-psm-set-use-key-value-for-lang-string.js";
export const jsonDataPsmExecutors = [
    CoreOperationExecutor.create(Operations.DataPsmSetUseKeyValueForLangString.is, executeDataPsmSetUseKeyValueForLangString, Operations.DataPsmSetUseKeyValueForLangString.TYPE),
];
//# sourceMappingURL=xml-data-psm-executor.js.map